import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { RenderEvent } from './render-events.model';


/** @deprecated Use CMSRenderEventsService instead */
@Injectable({
  providedIn: 'any'
})
export class RenderEventsService {

  /** @deprecated Use CMSRenderEventsService.emitEvent() and CMSRenderEventsService.getEvent() instead */
  public events = new Subject<RenderEvent>();

}
